import script from "./QuickpaySettingsPitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickpaySettingsPitch.vue?vue&type=script&setup=true&lang=ts"

import "./QuickpaySettingsPitch.vue?vue&type=style&index=0&id=05701619&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05701619"]])

export default __exports__